import { FormsActionTypes, FormsEntities, FormsHelpers } from '@bimser/common';
import { findMessage } from '@bimser/components';
import { RuleEngineEntities } from '@bimser/components/dist/BCRuleManager';
import { createSyncAction } from '@bimser/core';
import { put } from 'redux-saga/effects';

export function* runShowMessageAction(
	action: RuleEngineEntities.IShowMessageAction,
	windowId: string
) {
	const { dialogType, alertType, messages, highlightList } = action;

	const title = getTitle(alertType) ?? action.name;

	switch (dialogType) {
		case 'Toaster': {
			FormsHelpers.showToasterMessage(title, alertType, messages, highlightList);
			break;
		}
		case 'Popup': {
			FormsHelpers.showPopupMessage(title, alertType, messages);
			break;
		}
		case 'Summary': {
			const payload: FormsEntities.IShowSummaryMessagePayload = {
				windowId,
				messages: [
					{
						title,
						type: alertType,
						message: messages
					}
				]
			};

			yield put(
				createSyncAction(
					FormsActionTypes.SHOW_SUMMARY_MESSAGES,
					FormsEntities.ShowSummaryMessagePayloadFactoryFromJS(payload)
				)
			);

			break;
		}
		default:
			console.warn('The action type that you trying to run is not found!');
	}
}

const getTitle = (type: RuleEngineEntities.AlertType) => {
	switch (type) {
		case 'Success':
			return findMessage.get('101879');
		case 'Info':
			return findMessage.get('100647');
		case 'Error':
			return findMessage.get('100926');
		case 'Warning':
			return findMessage.get('100652');
	}
};
